<template>
  <el-row>
    <el-col>
      <el-form ref="form" :model="form" label-width="80px" label-position="top">
        <el-form-item label="Username">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Password">
          <el-input type="password" v-model="form.passwd"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" :loading="loading">Login</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'Login',
  title: 'LOGIN',
  data: function() {
    return {
      loading: false,
      form: {
        name: '',
        passwd: ''
      }
    }
  },
  mounted: function() {
    // this.$socket.on('connect', () => {
    //   // eslint-disable-next-line
    //   console.log('connected')
    // })
    // this.$socket.on('disconnect', () => {
    //   // eslint-disable-next-line
    //   console.log('disconnect')
    // })
    // this.$socket.on('err', err => {
    //   // eslint-disable-next-line
    //   console.log('err', err)
    // })
  },
  sockets: {
    connect() {
      // eslint-disable-next-line
      console.log('connected')
    }
  },
  methods: {
    onSubmit() {
      // eslint-disable-next-line
      // console.log('submit!')
      this.form.name = this.form.name.toLocaleLowerCase()
      this.loading = true
      this.$socket.emit('login', this.form, (err, user) => {
        // eslint-disable-next-line
        console.log(err, user, !err && user, this.$route.query.redirect || '/')
        this.loading = false
        if (!err && user) {
          this.$store.commit('account.UPDATE', user)
          this.$router.push({ path: this.$route.query.redirect || '/home' })
        } else {
          this.$message.error(err ? err : `The user does not exist or the password is incorrect!`)
        }
      })
    }
  }
}
</script>

<style scoped>
h1 > a {
  font-size: 16px;
}
</style>
